import React, { useEffect, useState } from "react";
import { crossIcon } from "../Images";
import RatingComponent from "./starRatingComponent";

const Custom = ({ value, setValue, id, isMobile }) => {
  const [resourceName, setResourceName] = useState("");
  const [resourceRating, setResourceRating] = useState(0);
  const [resourceComment, setResourceComment] = useState("");

  useEffect(() => {
    let nestedFieldData = value.nestedField.map(item => {
      if (item.id === id) {
        return {
          ...item,
          resourceName: resourceName,
          resourceRating: resourceRating,
          resourceComment: resourceComment
        };
      } else {
        return item;
      }
    });
    setValue({
      ...value,
      nestedField: nestedFieldData
    });
  }, [resourceName, resourceRating, resourceComment]);

  const deleteRow = id => {
    let item = value.nestedField;
    for (let i = 0; i < item.length; i++) {
      if (item[i].id == id) {
        item.splice(i, 1);
        break;
      }
    }
    setValue({
      ...value,
      nestedField: item
    });
  };

  return (
    <tr style={{ height: "5px" }} id={id}>
      <td width="30%" className={isMobile ? "formStyleNameDataSM" : "formStyleNameDataMD"}>
        <input
          className={isMobile ? "inputDataSM" : "inputDataMD"}
          type="text"
          onChange={e => {
            setResourceName(e.target.value);
          }}
        />
      </td>
      <td className={isMobile ? "formStyleRatingSM" : "formStyleRatingMD"}>
        <RatingComponent
          width="30%"
          fromNestedData
          setResourceRating={setResourceRating}
          resourceRating={resourceRating}
          isMobile={isMobile}
        />
      </td>
      <td width="40%" className={isMobile ? "formStyleCommentSM" : "formStyleCommentMD"}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%",
            width: "100%",
            justifyContent: "space-around",
            alignItems: "center"
          }}
        >
          <textarea
            className={isMobile ? "textareaDataSM" : "textareaDataMD"}
            type="text"
            onChange={e => {
              setResourceComment(e.target.value);
            }}
          />
          <div>
            <img
              src={crossIcon}
              className={isMobile ? "crossIconSM" : "crossIconMD"}
              onClick={() => {
                deleteRow(id);
              }}
            ></img>
          </div>
        </div>
      </td>
    </tr>
  );
};

const ResourceTable = props => {
  const { isMobile, data } = props;
  const [formData, setFormData] = useState({
    nestedField: [
      {
        id: "111",
        resourceName: "vishal joshi"
      }
    ]
  });
  let [noOfRows, setNoOfRows] = useState(1);

  const onSubmit = () => {
    data && data.saveResourceRating && data.saveResourceRating(formData.nestedField);
  };
  return (
    <div className={isMobile ? "containerSM" : "containerMD"}>
      <div>
        <table style={{ borderCollapse: "collapse", overflow: "hidden", width: "100%", marginTop:30 }}>
          <thead className="tableRow">
            <tr>
              <th width="30%" className={isMobile ? "formStyleNameHeadSM" : "formStyleNameHeadMD"}>
                RESOURCE NAME
              </th>
              <th width="30%" className={isMobile ? "formStyleRatingHeadSM" : "formStyleRatingHeadMD"}>
                YOUR FEEDBACK
              </th>
              <th width="40%" className={isMobile ? "formStyleCommentHeadSM" : "formStyleCommentHeadMD"}>
                COMMENT
              </th>
            </tr>
          </thead>
          <tbody>
            {formData.nestedField.map((item, index) => {
              return <Custom key={index} value={formData} setValue={setFormData} id={item.id} isMobile={isMobile} />;
            })}
          </tbody>
        </table>
        <p
          className={isMobile ? "addRowTextSM" : "addRowTextMD"}
          onClick={() => {
            setNoOfRows(noOfRows + 1);
            setFormData({
              ...formData,
              nestedField: [...formData.nestedField, { id: `1234KFN${noOfRows}` }]
            });
          }}
        >
          {" "}
          + Add Resource
        </p>
        {data && !data.starField && <p style={{ color: 'red' }}> *resource name, rating and comment all fields are mendatory</p>}
      </div>
      {data.subsidiaryName === "Unthinkable Solutions LLP" || data.subsidiaryName === "Hisar-Unthinkable Solutions LLP" ?
        <div className={isMobile ? "resourceFeedbackButtonSM unthinkable" : "resourceFeedbackButtonMD unthinkable"}>
          <div className={isMobile ? "resourceFeedbackTextSM" : "resourceFeedbackTextMD"} onClick={onSubmit}>
            Submit Resource Feedback
          </div>
        </div> :
        <div className={isMobile ? "resourceFeedbackButtonSM daffodil" : "resourceFeedbackButtonMD daffodil"}>
          <div className={isMobile ? "resourceFeedbackTextSM" : "resourceFeedbackTextMD"} onClick={onSubmit}>
            Submit Resource Feedback
          </div>
        </div>}
    </div>
  );
};

export default ResourceTable;
